'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide17eCoopTable({ id, registerRef }: Props) {
  const columns = [
  {
    header: 'Với sinh viên',
    desc: 'Các bạn không phải chi trả cho một trải nghiệm có giá trị cao nhưng vẫn nhận được chuyến đi miễn phí, chứng nhận, kỹ năng, hình ảnh, cơ hội được ghi nhận và kết nối cộng đồng xanh ý nghĩa.'
  },
  {
    header: 'Với nhà trường',
    desc: 'Nhà trường không cần tự xây lại từ đầu một chương trình lớn nhưng vẫn có một hoạt động cộng đồng chỉn chu, hình ảnh đẹp để truyền thông, số liệu rõ để báo cáo, và được ghi nhận là đơn vị đồng hành có trách nhiệm xã hội.'
  },
  {
    header: 'Với Tri An Green Travel',
    desc: 'Xây dựng được mô hình hợp tác dài hạn với nhà trường, mở rộng cộng đồng sinh viên tích cực và lan tỏa tinh thần sống xanh bằng trải nghiệm thật.'
  }];


  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#f5f0e8]">
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-16 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-10 text-center">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#1a4a2a] tracking-tight">
            Lợi ích cốt lõi của mô hình hợp tác
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="rounded-2xl border border-[rgba(26,74,42,0.25)] overflow-hidden">
            <div className="grid grid-cols-3">
              {columns.map((col, i) =>
              <div
                key={`coop-header-${i}`}
                className="px-6 py-4 bg-[rgba(26,74,42,0.08)] border-b border-[rgba(26,74,42,0.2)]"
                style={{ borderRight: i < 2 ? '1px solid rgba(26,74,42,0.2)' : 'none' }}>

                  <h3 className="font-display font-700 text-[16px] text-[#1a4a2a] text-center">{col.header}</h3>
                </div>
              )}
            </div>
            <div className="grid grid-cols-3">
              {columns.map((col, i) =>
              <div
                key={`coop-body-${i}`}
                className="px-6 py-6 bg-white/50"
                style={{ borderRight: i < 2 ? '1px solid rgba(26,74,42,0.15)' : 'none' }}>

                  <p className="font-body text-[14px] text-[#3a5a3a] leading-relaxed">{col.desc}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="fade-in-up rounded-2xl overflow-hidden h-[240px] md:h-[280px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_176fe6773-1767663909087.png"
            alt="Nhóm người đa dạng ngồi ăn uống vui vẻ ngoài trời giữa thiên nhiên xanh, thể hiện tinh thần cộng đồng và hợp tác"
            className="w-full h-full object-cover" />

        </div>
      </div>
    </SlideWrapper>);

}